import {
  AfterViewInit,
  Component,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';
import { WorkorderApiService } from 'src/app/services/api/workorder-api.service';
import { MessageService } from 'src/app/services/message.service';
import { NotifyService } from 'src/app/services/notify.service';
import { validateFormGroup } from 'src/app/utils/form';
import { EvaluateModalComponent } from '../evaluate-modal/evaluate-modal.component';
import { EvaluateAfterModalComponent } from '../evaluate-after-modal/evaluate-after-modal.component';

@Component({
  selector: 'app-workorder-detail-card',
  templateUrl: './workorder-detail-card.component.html',
  styleUrls: ['./workorder-detail-card.component.scss'],
})
export class WorkorderDetailCardComponent implements AfterViewInit {
  id: any = 0;
  formGroup: UntypedFormGroup;
  showTips = false;

  constructor(
    private fb: FormBuilder,
    private api: WorkorderApiService,
    private message: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private image: NzImageService,
    private notify: NotifyService,
    private dialog: MatDialog,
  ) {
    this.formGroup = this.fb.group({
      detail: ['', [Validators.required]],
      image: [[]],
    });

    this.route.queryParams.subscribe((params) => {
      this.id = params['id'];
      if (this.id !== 0) {
        this.getTicket();
      }
    });

    this.checkTipsTime();
  }

  @ViewChildren('textRef') textRefs!: QueryList<ElementRef>;

  ngAfterViewInit(): void {
    //富文本 图片放大
    this.textRefs.changes.subscribe(() => {
      this.bindZoomEvent();
    });
    // 首次绑定
    this.bindZoomEvent();
  }

  onInputChange(data: any) {
    this.formGroup.patchValue({
      detail: data.detail,
      image: data.image,
    });
  }

  checkTipsTime() {
    const now = new Date();
    const start = new Date(`2026-04-30 12:00:00`);

    this.showTips = false;
  }

  close() {
    var result = this.logs.find(
      (item: any) => item.sender === 'CustomerService',
    );
    if (!result) {
      this.message.warn('请先等客服回复', { position: 'top' });
      return;
    }
    this.dialog
      .open(EvaluateModalComponent, {
        width: '520px',
        data: result,
        panelClass: 'newModal',
      })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.afterEvaluateModal();
        }
      });
  }

  afterEvaluateModal() {
    this.dialog
      .open(EvaluateAfterModalComponent, {
        width: '563px',
      })
      .afterClosed()
      .subscribe((r) => {
        this.closeTicket();
      });
  }

  async closeTicket() {
    if (
      this.logs[0]?.workorder?.status === 'CustomerServiceCompletion' ||
      this.logs[0]?.workorder?.status === 'PassiveCompletion' ||
      this.logs[0]?.workorder?.status === 'ProactiveCompletion'
    ) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/user/profile/form']);
      });
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.closeTicket(this.id);
      if (r.status === 0) {
        // this.message.open('关闭成功');
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/form']);
          });
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  async reply() {
    if (
      this.logs[0]?.workorder?.status === 'CustomerServiceCompletion' ||
      this.logs[0]?.workorder?.status === 'PassiveCompletion' ||
      this.logs[0]?.workorder?.status === 'ProactiveCompletion' ||
      this.logs[0]?.workorder.status === 'ProcessCompleted' ||
      this.logs[0]?.workorder.status === 'Completed'
    ) {
      return;
    }
    if (!validateFormGroup(this.formGroup)) {
      return;
    }
    const value = this.formGroup.value;
    try {
      this.loading = true;
      const r = await this.api.postUserreply(
        this.id,
        value.detail,
        value.image,
      );
      if (r.status === 0) {
        this.message.open('提交成功');
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/form/workorder'], {
              queryParams: { id: this.id },
            });
          });

        //工单提醒
        this.notify.clearWorkorder();
      } else if (r.status === 1500) {
        this.message.warn('工单已完结，无法回复，如有问题请提交新工单');
        this.getTicket();
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  loading = false;
  logs: any[] = [];
  async getTicket() {
    try {
      this.loading = true;
      const r = await this.api.getTicket(this.id);
      this.logs = r.data || [];

      if (this.logs[0]?.workorder.status === 'ProcessCompleted') {
        this.changeProcessCompleted();
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  preview(img: any) {
    if (!img) {
      return;
    }
    const image: NzImage = {
      src: img,
    };
    this.image.preview([image]);
  }

  bindZoomEvent() {
    this.textRefs.forEach((textEl: ElementRef) => {
      const imgs = textEl.nativeElement.querySelectorAll('img');
      imgs.forEach((img: HTMLImageElement) => {
        img.addEventListener('click', () => {
          this.preview(img.src);
        });
      });
    });
  }

  isHoliday(): boolean {
    const now = new Date();
    const startDate = new Date(2026, 1, 14, 0, 0, 0);
    const stopDate = new Date(2026, 1, 24, 0, 0, 0);

    return now >= startDate && now < stopDate;
  }

  statusMap: Record<string, { text: string; class: string }> = {
    ReplyReceived: {
      text: '等待您的回复',
      class: 'old',
    },
    NoResponseReceived: {
      text: '新工单',
      class: 'new',
    },
    ProactiveCompletion: {
      text: '已完结',
      class: 'close',
    },
    PassiveCompletion: {
      text: '已完结',
      class: 'close',
    },
    CustomerServiceCompletion: {
      text: '已完结',
      class: 'close',
    },
    Processing: {
      text: '处理中',
      class: 'processing',
    },
    Supplemented: {
      text: '已补充',
      class: 'supplemented',
    },
    NeedToSupplement: {
      text: '需补充',
      class: 'need-to-supplement',
    },
    ProcessCompleted: {
      text: '处理完成',
      class: 'process-completed',
    },
    Completed: {
      text: '已完成',
      class: 'completed',
    },
  };

  get workorderStatus() {
    return this.statusMap[this.logs?.[0]?.workorder?.status];
  }

  async changeProcessCompleted() {
    try {
      this.loading = true;
      await this.api.changeProcessCompleted(this.id);
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
